import { IProductFilter } from '~/src/components/ConnectDomruPopup/context/constants';
import { TInitialState } from '~/src/components/ConnectDomruPopup/context/initialState';

export const selectFilters = (state: TInitialState): IProductFilter[] => state.productFilters;
